const wordsObject = {
  solutions: [
    { word: "Abuse", id: 1 },
    { word: "Adult", id: 2 },
    { word: "Agent", id: 3 },
    { word: "Anger", id: 4 },
    { word: "Apple", id: 5 },	
    { word: "Award", id: 6 },
    { word: "Basis", id: 7 },
    { word: "Beach", id: 8 },
    { word: "Birth", id: 9 },
    { word: "Block", id: 10 },
    { word: "Blood", id: 11 },
    { word: "Board", id: 12 },
    { word: "Brain", id: 13 },
    { word: "Bread", id: 14 },
    { word: "Break", id: 15 },
    { word: "Brown", id: 16 },
    { word: "Buyer", id: 17 },
    { word: "Cause", id: 18 },
    { word: "Chain", id: 19 },
    { word: "Chair", id: 20 },
    { word: "Chest", id: 21 },
    { word: "Chief", id: 22 },
    { word: "Child", id: 23 },
    { word: "China", id: 24 },
    { word: "Claim", id: 25 },
    { word: "Class", id: 26 },
    { word: "Clock", id: 27 },
    { word: "Coach", id: 28 },
    { word: "Coast", id: 29 },
    { word: "Court", id: 30 },
    { word: "Cover", id: 31 },
    { word: "Cream", id: 32 },
    { word: "Crime", id: 33 },
    { word: "Cross", id: 34 },
    { word: "Crowd", id: 35 },
    { word: "Crown", id: 36 },
    { word: "Cycle", id: 37 },
    { word: "Dance", id: 38 },
    { word: "Death", id: 39 },
    { word: "Depth", id: 40 },
    { word: "Doubt", id: 41 },
    { word: "Draft", id: 42 },
    { word: "Drama", id: 43 },
    { word: "Dream", id: 44 },
    { word: "Dress", id: 45 },
    { word: "Drink", id: 46 },
    { word: "Drive", id: 47 },
    { word: "Earth", id: 48 },
    { word: "Enemy", id: 49 },
    { word: "Entry", id: 50 },
  ],

  letters: [
    { key: "Q" },
    { key: "W" },
    { key: "E" },
    { key: "R" },
    { key: "T" },
    { key: "Y" },
    { key: "U" },
    { key: "I" },
    { key: "O" },
    { key: "P" },
    { key: "A" },
    { key: "S" },
    { key: "D" },
    { key: "F" },
    { key: "G" },
    { key: "H" },
    { key: "J" },
    { key: "K" },
    { key: "L" },
    // { key: "ENTER" },
    { key: "Z" },
    { key: "X" },
    { key: "C" },
    { key: "V" },
    { key: "B" },
    { key: "N" },
    { key: "M" },
  ],
}

export default wordsObject
